import { useCallback } from 'react';
import { useToast } from 'components/crm/ui/Toast';
import useText from 'hooks/useText';
import {
  clockParts,
  inCallWindow,
  readCallRules,
} from 'pages/prospection/callTime';

/**
 * Wraps a « Call » gesture: the call always goes out, and outside the call
 * window (Martinique time) a toast says so. `callRules` as read on /calls/day.
 */
const useCallWindowWarning = (callRules, onCall) => {
  const { text } = useText('prospection');
  const toast = useToast();
  const { start, end } = readCallRules(callRules).callWindow;
  return useCallback(
    (...args) => {
      onCall(...args);
      const now = new Date();
      if (inCallWindow(now, { start, end })) return;
      toast(text('callWindow.outside', clockParts(now)), 'error');
    },
    [onCall, start, end, text, toast],
  );
};

export default useCallWindowWarning;
